import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

import { SelectListItemModel } from '../../../models';
import { CustomerProfileEditModel } from '../../../models/customer';
import { MessageService, MasterDataService, CustomerService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'user-profile-edit',
    templateUrl: './profile.edit.component.html'
})

export class ProfileEditComponent implements OnInit {
    @BlockUI('conatiner-profile') blockUI: NgBlockUI;
    @BlockUI('conatiner-upload-image') uploadImageBlockUI: NgBlockUI;

    constructor(private vcr: ViewContainerRef,
        private router: Router,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private datepickerConfig: NgbDatepickerConfig,
        private messageService: MessageService,
        private masterDataService: MasterDataService,
        private customerService: CustomerService,
        private appUtils: AppUtils) {
        this.toastr.setRootViewContainerRef(this.vcr);

        const currentDate = new Date();
        datepickerConfig.minDate = { year: 1900, month: 1, day: 1 };
        datepickerConfig.maxDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
        datepickerConfig.outsideDays = 'collapsed';
    }

    educationLevels: Array<SelectListItemModel> = new Array<SelectListItemModel>();
    model: CustomerProfileEditModel = new CustomerProfileEditModel();
    specializationsTags: any = [];
    modalReference: any;
    uploadedFileKey: string;
    uploadedFileUrl: string;

    ngOnInit() {
        this.loadEducationLevels();
        this.loadProfile();
    }

    loadEducationLevels() {
        this.masterDataService.getEducationLevels()
            .subscribe(
                (data: any) => {
                    Object.assign(this.educationLevels, data);
                },
                error => {
                    console.log(error);
                });
    }

    loadProfile() {
        this.blockUI.start();
        this.customerService.getProfile()
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    Object.assign(this.model, data);
                    this.model.dateOfBirth = this.appUtils.getDateForNgDatePicker(this.model.dateOfBirth);
                    this.specializationsTags = this.model.specializationTags;
                    if (!this.model.highestEducationLevelId) {
                        this.model.highestEducationLevelId = '';
                    }
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    open(content: any) {
        this.modalReference = this.modalService.open(content);
    }

    close() {
        this.uploadedFileKey = null;
        this.uploadedFileUrl = null;
        this.modalReference.close();
    }

    onFileSelected(event: any) {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files.item(0);
            if (file == null) {
                this.toastr.error('Please select a valid image file.');
                return;
            }
            this.uploadImageBlockUI.start();
            this.customerService.uploadProfileImage(file)
                .subscribe(
                    (data: any) => {
                        this.uploadImageBlockUI.stop();
                        this.uploadedFileKey = data.fileKey;
                        this.uploadedFileUrl = data.fileUrl;
                        this.toastr.success('Profile image has been uploaded successfully.');
                    },
                    (error: any) => {
                        this.uploadImageBlockUI.stop();
                        this.appUtils.ProcessErrorResponse(this.toastr, error);
                    }
                );
        }
    }

    updateProfileImage() {
        if (!this.uploadedFileKey) {
            this.toastr.error('Please upload the image file to continue.');
            return;
        }
        this.uploadImageBlockUI.start();
        this.customerService.updateProfileImage({ uploadedFileName: this.uploadedFileKey })
            .subscribe(
                () => {
                    this.uploadImageBlockUI.stop();
                    this.model.profileImage = this.uploadedFileKey;
                    this.model.profileImageUrl = this.uploadedFileUrl;
                    this.messageService.loadCurrentUserProfile();
                    this.close();
                },
                error => {
                    this.uploadImageBlockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    submit() {
        this.model.dateOfBirth = this.appUtils.getFormattedDate(this.model.dateOfBirth, null);
        if (this.specializationsTags && this.specializationsTags.length !== 0) {
            this.specializationsTags.map((item: any) => {
                this.model.specializationTags.push(item.value);
            });
        }

        this.blockUI.start();
        this.customerService.updateProfile(this.model)
            .subscribe(
                () => {
                    this.router.navigate(['/user/profile-detail']);
                    setTimeout(() => {
                        this.messageService.loadCurrentUserProfile();
                        this.toastr.success('Your profile has been updated successfully.');
                    }, 100);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/profile-edit/profile.edit.component.ts